module.exports = __webpack_public_path__ + "img/page_3_b_pic_1.428927ec.png";